import { createAction, props } from '@ngrx/store';
import {
  CommentFilterOptionDefinition,
  CommentingConfig,
  CommentingResourceModel,
  ThreadSort,
  ThreadViewModel
} from '../../models';

export const CommentingPanelActionType = {
  Open: '[CommentingPanel] Open',
  Close: '[CommentingPanel] Close',
  ClearStateAfterClosing: '[CommentingPanel] Clear state after closing',
  Destroy: '[CommentingPanel] Destroy',
  InitializeCommentingPanel: '[CommentingPanel] Initialize commenting panel',
  AddNewResources: '[CommentingPanel] Add new resources',
  SetResourceViewModels: '[CommentingPanel] Set resource view models',
  FocusResource: '[CommentingPanel] Focus resource',
  EditThread: '[CommentingPanel] Edit thread',
  EditComment: '[CommentingPanel] Edit comment',
  CloseEdit: '[CommentingPanel] Close edit',
  ReplyToThread: '[CommentingPanel] Reply to thread',
  CloseReplyToThread: '[CommentingPanel] Close reply to thread',
  CreateThreadForResource: '[CommentingPanel] Create thread for resource',
  DisplayAllThreadsAction: '[CommentingPanel] Display all threads action',
  DisplaySingleThread: '[CommentingPanel] Display single thread',
  CloseSingleThreadDisplay: '[CommentingPanel] Close display single thread',
  CloseThreadCreation: '[CommentingPanel] Close thread creation',
  SetFilterOption: '[CommentingPanel] Set filter option',
  ChangeSortingOption: '[CommentingPanel] Change sorting option',
};

export const OpenAction = createAction(CommentingPanelActionType.Open);

export const CloseAction = createAction(CommentingPanelActionType.Close);

export const ClearStateAfterClosingAction = createAction(CommentingPanelActionType.ClearStateAfterClosing);

export const DestroyAction = createAction(CommentingPanelActionType.Destroy);

export const InitializeCommentingPanelAction = createAction(
  CommentingPanelActionType.InitializeCommentingPanel,
  props<{ commentingConfig: CommentingConfig }>()
);

export const AddNewResourcesAction = createAction(
  CommentingPanelActionType.AddNewResources,
  props<{ resources: CommentingResourceModel[] }>(),
);

export const SetResourceViewModelsAction = createAction(
  CommentingPanelActionType.SetResourceViewModels,
  props<{ threadViewModels: ThreadViewModel[] }>()
);

export const FocusResourceAction = createAction(
  CommentingPanelActionType.FocusResource,
  props<{ resourceType: string; resourceId: string }>()
);

export const EditThreadAction = createAction(
  CommentingPanelActionType.EditThread,
  props<{ threadId: string }>(),
);

export const EditCommentAction = createAction(
  CommentingPanelActionType.EditComment,
  props<{ commentId: string }>(),
);

export const CloseEditAction = createAction(CommentingPanelActionType.CloseEdit);

export const ReplyToThreadAction = createAction(
  CommentingPanelActionType.ReplyToThread,
  props<{ threadId: string }>(),
);

export const CloseReplyToThreadAction = createAction(CommentingPanelActionType.CloseReplyToThread);

export const CreateThreadForResourceAction = createAction(
  CommentingPanelActionType.CreateThreadForResource,
  props<{ resourceType: string; resourceId: string }>()
);

export const DisplayAllThreadsAction = createAction(CommentingPanelActionType.DisplayAllThreadsAction);

export const DisplaySingleThreadAction = createAction(
  CommentingPanelActionType.DisplaySingleThread,
  props<{ resourceId: string }>(),
);

export const CloseSingleThreadDisplayAction = createAction(CommentingPanelActionType.CloseSingleThreadDisplay);

export const CloseThreadCreationAction = createAction(CommentingPanelActionType.CloseThreadCreation);

export const SetFilterOptionAction = createAction(
  CommentingPanelActionType.SetFilterOption,
  props<{ selectedFilterOption: CommentFilterOptionDefinition }>(),
);

export const ChangeSortingOptionAction = createAction(
  CommentingPanelActionType.ChangeSortingOption,
  props<{ selectedSortOption: ThreadSort }>(),
);
